import { Component, Story } from './DocTypes';

const CardStory: Story = {
  title: 'Card',
  description: 'A card that uses tag-data-binder to render data on the card',
  coreComponent: {
    html: `<tag-data-binder>
  <tag-card version="2" style="width:200px;">
    <div style="padding: 10px">
      <div style="text-align: center; margin-bottom: 10px">
        <tag-avatar
          src="{{imageUrl}}"
          size="100px"
          placeholder="{{initials}}">
        </tag-avatar>
      </div>
      <div style="text-align: center; margin-bottom: 10px">
        <tag-text type="h2" text="{{name}}"></tag-field>
      </div>
      <div style="display: flex;">
        <tag-text type="edit-field-label" text="Date of Birth" text-style='{"width": "100px", "display": "inline-block"}'></tag-text>
        <tag-text type="span" text="{{dob}}"></tag-text>
      </div>
      <div style="display: flex;">
        <tag-text type="edit-field-label" text="Gender" text-style='{"width": "100px", "display": "inline-block"}'></tag-text>
        <tag-text type="span" text="{{gender}}"></tag-text>
      </div>
    </div>
  </tag-card>
</tag-data-binder>`,
    js: `var dataBinder = document.querySelector('tag-data-binder');
dataBinder.data = {
  name: 'Jerry Jeep',
  initials: 'JJ',
  imageUrl: 'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
  dob: '13 Feb 1990',
  gender: 'Male'
};
`,
  },
};

const TagHttpStory: Story = {
  title: 'tag-http',
  description: 'Data rendered in a card via tag-data-binder and tag-http',
  coreComponent: {
    html: `<tag-http path="https://swapi.dev/api/people/1" response-type="object" no-headers>
  <tag-data-binder hide-children-when-no-data>
    <tag-card version="2" style="width:200px;">
      <div style="padding: 10px">
        <div style="text-align: center; margin-bottom: 10px">
          <tag-text type="h2" text="{{name}}"></tag-text>
        </div>
        <div style="display: flex;">
          <tag-text type="edit-field-label" text="Hair colour" text-style='{"width": "100px", "display": "inline-block"}'></tag-text>
          <tag-text type="span" text="{{hair_color}}"></tag-text>
        </div>
        <div style="display: flex;">
          <tag-text type="edit-field-label" text="Birth year" text-style='{"width": "100px", "display": "inline-block"}'></tag-text>
          <tag-text type="span" text="{{birth_year}}"></tag-text>
        </div>
        <div style="display: flex;">
          <tag-text type="edit-field-label" text="Gender" text-style='{"width": "100px", "display": "inline-block"}'></tag-text>
          <tag-text type="span" text="{{gender}}"></tag-text>
        </div>
      </div>
    </tag-card>
  </tag-data-binder>
</tag-http>
`,
  },
};
export const TagDataBinderDocs: Component = {
  type: 'component',
  name: 'data-binder',
  description:
    'Stores a data object and allows child elements to bind to it using double curley bracket binding expressions. This is a html only component because you have the full power of JSX in React',
  mobileFriendly: true,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'data',
      description: 'The data object',
      type: 'any',
    },
    {
      name: 'hideChildrenWhenNoData',
      description: 'Does render any children if the data prop is null or undefined',
      type: 'boolean',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [
    {
      name: 'setData',
      description: 'The data object',
      parameters: [
        {
          name: 'data',
          description: 'The data object to bind',
          type: 'any',
        },
      ],
      returnType: 'void',
    },
  ],
  stories: [CardStory, TagHttpStory],
};
